import {USD_DISPLAY_DECIMALS} from '@/constants/config'
import {useCurrencySymbol} from '@/lib/locale/country'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'
import roundToNDecimal from '@/utils/numbers/roundToNDecimals'

interface Props {
  price: number | string
}

export default memo(function CategoryItemPrice({price}: Props) {
  const currencySymbol = useCurrencySymbol()

  const roundedPrice = typeof price === 'string' ? false : roundToNDecimal(price)

  return (
    <div>
      {roundedPrice ? (
        <>
          <VisuallyHidden>{`Price: ${currencySymbol}${roundedPrice}`}</VisuallyHidden>
          <span aria-hidden>{currencySymbol}</span>
          <span aria-hidden>{roundedPrice.toFixed(USD_DISPLAY_DECIMALS)}</span>
        </>
      ) : (
        <>
          <VisuallyHidden>{`Price: ${price}`}</VisuallyHidden>
          <span aria-hidden>{currencySymbol}</span>
          <span aria-hidden>{price}</span>
        </>
      )}
    </div>
  )
})
